import React, { useState } from "react";
import API from "../../Services/BaseService";
import { useHistory } from "react-router-dom";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import "../../Component/CommonPopup/commonPopup.css"
import checkImg from '../../assets/img/check.png';
import errorImg from '../../assets/img/close.png';
import { useSelector } from "react-redux";
// import ErrorPopup from "../../../../Container/ErrorPage/ErrorPopup";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import ls from "local-storage";
const Approve = (props) => {
    console.log("props", props)

    const { carId, flag } = props
    const adminData = useSelector(state => state.LoginReducer.payload);
    const history = useHistory();
    const [isOpenPrivileges, setIsOpenPrivileges] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    const [errors1, setErrors1] = useState("");
    const [errorFlag, setErrorFlag] = useState(false)
    const [alertmessage, setAlertMessage] = useState("");
    const [alerttitle, setAlertTitle] = useState("");
    const [alertimg, setAlertImg] = useState("");
    const [toggleCityPopupOpen, setToggleCityPopupOpen] = useState(true);
    const [errors12, setErrors12] = useState(false);
    console.log("toggleCityPopupOpen", toggleCityPopupOpen, "errors12", errors12)
    const sellerData = useSelector(state => state.LoginReducer.payload);
    const [errors, setErrors] = useState("");

    const carsDetDelete = () => {

        let request = {
            car_id: carId,
            seller_id: sellerData.seller_id,
            seller_token: sellerData.seller_token,
        };

        API.post("carDetailsdelete/update", request).then((response) => {
            if (response.data.success) {

                setToggleCityPopupOpen(false);
                setAlertImg(checkImg);
                setAlertTitle("Car Delete")
                setAlertMessage("Car Successfully Deleted")
            } else {
                setToggleCityPopupOpen(false);
                setAlertImg(errorImg);
                setAlertTitle("Car Delete");
                setAlertMessage(response.data.error.err);
            }
        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error)
                setErrorFlag(true)
            }
        });
    };

    const carsInactive = () => {

        let request = {
            car_id: carId,
            seller_id: sellerData.seller_id,
            seller_token: sellerData.seller_token,

        };

        API.post("carinactive/update", request).then((response) => {
            if (response.data.success) {
                setToggleCityPopupOpen(false);
                setAlertImg(checkImg);
                setAlertTitle("Car Inactive")
                setAlertMessage("Car Successfully Inactivated")
            } else {
                setToggleCityPopupOpen(false);
                setAlertImg(errorImg);
                setAlertTitle("Car Inactive");
                setAlertMessage(response.data.error.err);
            }
        }).catch(function (error) {
            if (error.response) {
                setErrors(error.response.data.error)
                setErrorFlag(true)
            }
        });
    };
    const togglePopup = () => {
        setIsOpenPrivileges(!isOpenPrivileges);
    }

    return (
        <div>

            {toggleCityPopupOpen ?
                (<>

                    <Modal show={true} onHide={props.toggle} >
                        <Modal.Header className='Terms-login'>
                            <h2 > {flag === "Inactive" ? "INACTIVE CONFIRMATION" : "DELETE CONFIRMATION"}</h2>
                        </Modal.Header>
                        <Modal.Body>
                            {flag === "Inactive" ?
                                <p className="deletemsg">Are you sure you want to Inactive the car</p> :
                                <p className="deletemsg">Are you sure you want to delete the car</p>}

                            <div class="col-md-12 inactivebtns">
                                <button type="button" class="cta-btns" onClick={props.toggle} >Cancel</button>
                                {flag === "Inactive" ?
                                    <button type="button" class="cta-btns" onClick={carsInactive}>Inactive</button> :
                                    <button type="button" class="cta-btns" onClick={carsDetDelete}>Delete</button>}
                            </div>
                        </Modal.Body>
                    </Modal>
                </>) :
                (
                    <Modal show={true} onHide={props.toggle} >
                        <Modal.Header className='Terms-login'>
                            <h2 className="title">{alerttitle}</h2>
                        </Modal.Header>
                        <Modal.Body>
                        <div className="CommonModalbody">
                                <img className={alertimg === "" ? "successImg " : "errorImg"} src={alertimg} />
                            </div>
                            <div class="col-md-12">
                                <p className="deletemsg">{alertmessage}</p>
                                <div class="col-md-12 inactivebtns">
                                    {flag === "Inactive" ?
                                        <button type="button" className="cta-btns" onClick={() => history.push("/carList")}>Ok</button> :
                                        <button type="button" className="cta-btns" onClick={() => {history.push("/inactivecar");ls.set("carStatus", "Deleted")}}>Ok</button>}
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                )}

            {isOpenPrivileges &&
                <CommonPopup
                    handleClose={togglePopup}
                    popupTitle={popupTitle}
                    popupMsg={popupMsg}
                    popupType={popupType}
                    popupActionType={popupActionType}
                    popupActionValue={popupActionValue}
                    popupActionPath={popupActionPath}
                />
            }
        </div>
    )
}
export default Approve;